import React, { useState } from 'react'
import Checkbox from '@mui/material/Checkbox'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import Typography from '@mui/material/Typography'
import { IssueLabel } from '../../../../components/entities/IssueLabel'
import { ConvertibleLabel } from '../../../../components/entities/ConvertibleLabel'
import Button from '@mui/material/Button'
import { IssueEntity } from 'types/IssueEntity'
import { ConvertibleEntity } from 'types/ConvertibleEntity'
import Tooltip from '@mui/material/Tooltip'

export function AllCompanyIssues({
    issues,
    convertibles,
    handleCreateGroup,
    hasReachedMaxIssueGroups,
    isGuarantorFeeIssue,
    isIssuePage,
}: {
    handleCreateGroup: (entities: Array<ConvertibleEntity | IssueEntity>) => void
    hasReachedMaxIssueGroups: boolean
    isGuarantorFeeIssue: boolean
    isIssuePage: boolean
    issues: IssueEntity[] | null
    convertibles: ConvertibleEntity[] | null
}) {
    const [selected, setSelected] = useState<Array<IssueEntity | ConvertibleEntity>>([])
    const handleToggle = (entity: IssueEntity | ConvertibleEntity) => {
        const selectedIndex = selected.findIndex((i) => i.id === entity.id)
        if (selectedIndex === -1) {
            setSelected([...selected, entity])
        } else {
            setSelected(selected.filter((i) => i.id !== entity.id))
        }
    }
    const handleClick = () => {
        handleCreateGroup(selected)
    }

    // sort entities by publication date
    const entitiesSorted = [
        ...(issues || []).filter((i) => {
            if (i.type === 'Guarantor fee issue') return false

            if (isGuarantorFeeIssue) return ['Rights issue', 'IPO'].includes(i.type)

            return true
        }),
        ...(convertibles || []),
    ].sort((a, b) => {
        const aDate =
            a.publicationDate || a.sources.find((source) => source.sourceType === 'Publication')?.publishedDate
        const bDate =
            b.publicationDate || b.sources.find((source) => source.sourceType === 'Publication')?.publishedDate

        return (aDate ?? 0) > (bDate ?? 0) ? -1 : 1
    })

    return (
        <>
            <Typography variant='body2'>
                {`Skapa ny länkgrupp med aktuell ${isIssuePage ? 'emission' : 'konvertibel'} och de markerade nedan`}
            </Typography>
            <List>
                {entitiesSorted.map((entity) => (
                    <ListItem key={entity.id}>
                        <ListItemButton onClick={() => handleToggle(entity)}>
                            <ListItemIcon sx={{ minWidth: '30px' }}>
                                <Checkbox edge='start' checked={selected.some((i) => i.id === entity.id)} />
                            </ListItemIcon>
                            {'type' in entity ? (
                                <IssueLabel issue={entity} adminLink />
                            ) : (
                                <ConvertibleLabel convertible={entity} adminLink />
                            )}
                        </ListItemButton>
                    </ListItem>
                ))}
                <ListItem>
                    <Tooltip
                        title={
                            hasReachedMaxIssueGroups &&
                            'Ta bort en existerande länkgrupp för att kunna lägga till fler.'
                        }
                    >
                        <Button
                            disabled={hasReachedMaxIssueGroups}
                            variant='outlined'
                            onClick={handleClick}
                            sx={{ '&.Mui-disabled': { pointerEvents: 'auto' } }}
                        >
                            {`Skapa ny länkgrupp för denna ${isIssuePage ? 'emission' : 'konvertibel'} och markerade`}
                        </Button>
                    </Tooltip>
                </ListItem>
            </List>
        </>
    )
}
